module.exports = __webpack_public_path__ + "img/reminders-icon.de7022b3.png";